<app-verify-identity-phone-number
  (toggleForm)="toggleOpen($event)"
></app-verify-identity-phone-number>
<app-verify-identity-modal-form *ngIf="open"></app-verify-identity-modal-form>

<div class="footer-link">
  Having trouble?
  <a routerLink="/logout" class="link">Log out</a>
</div>
